import {makeStyles} from "@material-ui/core/styles";
import {FeAvailability} from "../redux/types";
import React, {FC} from "react";
import {useHistory, useRouteMatch} from "react-router-dom";
import {useEditorLocation} from "../../../editor/editor.hook";
import {
    Button,
    Card,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Typography
} from "@material-ui/core";
import {formatDate} from "../../../date.utils";
import {useAppDispatch} from "../../../redux/redux.hook";
import {deleteAvailabilityThunk} from "../redux/availabilities.thunk";

const useStyles = makeStyles((theme) => ({
    cancelAvailabilityButton: {
        /*  backgroundColor: theme.palette.error.main,*/
        color: theme.palette.error.main
    },
    spacingBottom: {
        marginBottom: theme.spacing(2)
    }
}));

interface CancelAvailabilityDialogProps {
    availability: FeAvailability;
}

export const CancelAvailabilityDialog: FC<CancelAvailabilityDialogProps> = ({availability}) => {
    const classes = useStyles();
    const dispatch = useAppDispatch();
    const {url} = useRouteMatch();
    const history = useHistory();
    const {mode, reference} = useEditorLocation();
    const dialogOpen = mode === "edit" && reference === "cancel-availability";
    const closeDialog = () => history.replace({pathname: url, search: undefined, hash: undefined});

    const handleCancelAvailability = () => {
        dispatch(deleteAvailabilityThunk({id: availability.id}))
            .then(() => closeDialog())
            .catch(() => {})
    };

    return (
        <Dialog open={dialogOpen}>
            <DialogTitle>
                <Typography
                    variant="inherit"
                    color="secondary"
                >
                    Verfügbarkeit Absagen
                </Typography>
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Willst du wirklich folgende Verfügbarkeit löschen?
                </DialogContentText>
                <Card variant="outlined" style={{padding: 8}}>
                 <Typography variant="h6" color="secondary">
                     {formatDate(availability.from, "EEEE, dd.MM.yyyy")}
                 </Typography>
                    <Typography color="secondary">
                        {formatDate(availability.from, "HH:mm")} - {formatDate(availability.to, "HH:mm")}
                    </Typography>
                </Card>
            </DialogContent>
            <DialogActions>
                <Button onClick={closeDialog}>
                    Abbrechen
                </Button>
                <Button
                    className={classes.cancelAvailabilityButton}
                    onClick={handleCancelAvailability}
                >
                    Absagen
                </Button>
            </DialogActions>
        </Dialog>
    )
}


